import { APP_INITIALIZER } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { WHATS_APP_CONTACT_BASE_ROUTES } from './whats-app-contact-base.routes';
import { ManageProfileTabsService } from '@volo/abp.ng.account/public/config';
import { WhatsAppContactDetailComponent } from '../components/whats-app-contact-detail.component';

export const WHATS_APP_CONTACTS_WHATS_APP_CONTACT_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [ManageProfileTabsService],
    multi: true,
  }
];

function configureRoutes(tabs: ManageProfileTabsService) {
  return () => {
      tabs.add([
        {
          name: "Whatsapp",
          order: 6,
          // Sem a permissão a aba nem aparece (mesmo padrão da aba Usuários e Acessos). Antes,
          // qualquer usuário via a aba e levava 403 ao clicar — feedback do Ícaro 14/08.
          requiredPolicy: 'cargo_fleet.WhatsAppContacts',
          component: WhatsAppContactDetailComponent,
        },
      ]);
      };
}
